export enum RefundCaseStatusEnum {
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  INITIATED = 'INITIATED',
  PROCESSED = 'PROCESSED'
}
